<form [formGroup]="form" (ngSubmit)="submit()" class="p-4">
  <p class="mb-3">{{ "QUOTE.DRAWING.DIALOG.START_DRAWING_DESCRIPTION" | translate }}</p>

  <div class="mb-3">
    <p-inputgroup>
      <p-inputgroup-addon><i class="pi pi-calendar"></i></p-inputgroup-addon>
      <p-floatlabel variant="on" class="flex-1">
        <p-datepicker
          inputId="estimatedCompletion"
          formControlName="estimatedCompletion"
          dateFormat="yy-mm-dd"
          [showIcon]="false"
          [appendTo]="'body'"
          styleClass="w-full"
        ></p-datepicker>
        <label for="estimatedCompletion">{{ "QUOTE.DRAWING.DIALOG.ESTIMATED_COMPLETION_LABEL" | translate }} *</label>
      </p-floatlabel>
    </p-inputgroup>
    <app-core-errors [control]="form.get('estimatedCompletion')"></app-core-errors>
  </div>

  <div class="mb-3">
    <p-inputgroup>
      <p-inputgroup-addon><i class="pi pi-pencil"></i></p-inputgroup-addon>
      <p-floatlabel variant="on" class="flex-1">
        <p-select
          inputId="drawerId"
          formControlName="drawerId"
          [options]="drawers()"
          optionLabel="name"
          optionValue="id"
          [placeholder]="'QUOTE.DRAWING.DIALOG.SELECT_DRAWER_PLACEHOLDER' | translate"
          [loading]="loadingDrawers()"
          styleClass="w-full"
          [appendTo]="'body'"
        ></p-select>
        <label for="drawerId">{{ "QUOTE.DRAWING.DIALOG.SELECT_DRAWER" | translate }} *</label>
      </p-floatlabel>
    </p-inputgroup>
    <app-core-errors [control]="form.get('drawerId')"></app-core-errors>
  </div>

  <div class="flex justify-content-end gap-2 mt-4">
    <p-button [label]="'QUOTE.DRAWING.DIALOG.CANCEL' | translate" [text]="true" (onClick)="closeDialog()" />
    <p-button type="submit" [label]="'QUOTE.DRAWING.DIALOG.CONFIRM' | translate" [disabled]="form.invalid" />
  </div>
</form>
